import {RequestStatus} from "../../request";
import {AccountInfo} from "./reducer";

export const PersistAccountDetailsAction = (
    companyName: string,
    companyStreet: string,
    companyCity: string,
    companyPostalCode: string,
    companyCountry: string,
    companyVatId: string | null,
) => {
    return {
        type: 'authentication-persist-account-details',
        companyName: companyName,
        companyStreet: companyStreet,
        companyCity: companyCity,
        companyPostalCode: companyPostalCode,
        companyCountry: companyCountry,
        companyVatId: companyVatId,
    }
}

export const SignUpAction = (
    mail: string,
    password: string,
    firstName: string,
    lastName: string,
    companyName: string,
    companyStreet: string,
    companyCity: string,
    companyPostalCode: string,
    companyCountry: string,
    companyVatId: string | null,
) => {
    return {
        type: 'authentication-update-sign-up',
        mail: mail,
        password: password,
        firstName: firstName,
        lastName: lastName,
        companyName: companyName,
        companyStreet: companyStreet,
        companyCity: companyCity,
        companyPostalCode: companyPostalCode,
        companyCountry: companyCountry,
        companyVatId: companyVatId,
    }
}

export const FetchAccountDetails = () => {
    return {
        type: 'authentication-fetch-account-details',
    }
}

export const FetchBalance = () => {
    return {
        type: 'authentication-fetch-balance',
    }
}

export const UpdateCouponAmountRemainingAction = (value: number) => {
    return {
        type: 'authentication-update-coupon-remaining',
        value: value,
    }
}

export const UpdateHasUsedCoupon = (hasUsedCoupon: boolean) => {
    return {
        type: 'authentication-update-has-used-coupon',
        hasUsedCoupon: hasUsedCoupon,
    }
}

export const RedeemCouponAction = (code: string) => {
    return {
        type: 'authentication-redeem-coupon',
        code: code,
    }
}

export const SignInAction = (mail: string, password: string) => {
    return {
        type: 'authentication-update-sign-in',
        mail: mail,
        password: password,
    }
}

export const PersistChangedPasswordAction = (password: string, updatedPassword: string) => {
    return {
        type: 'authentication-change-password',
        password: password,
        updatedPassword: updatedPassword
    }
}

export const UpdateSignInRequestState = (requestState: RequestStatus) => {
    return {
        type: 'authentication-update-sign-in-request-state',
        requestState: requestState,
    }
}

export const UpdateSignUpRequestState = (requestState: RequestStatus) => {
    return {
        type: 'authentication-update-sign-up-request-state',
        requestState: requestState,
    }
}

export const UpdateChangePasswordRequestState = (requestState: RequestStatus) => {
    return {
        type: 'authentication-update-change-password-request-state',
        requestState: requestState,
    }
}

export const UpdateAccountInfoPersistRequestState = (requestState: RequestStatus) => {
    return {
        type: 'authentication-update-account-info-persist-request-state',
        requestState: requestState,
    }
}

export const UpdateFetchBalanceRequestState = (requestState: RequestStatus) => {
    return {
        type: 'authentication-update-fetch-balance-request-state',
        requestState: requestState,
    }
}

export const UpdateRedeemCouponRequestState = (requestState: RequestStatus) => {
    return {
        type: 'authentication-update-redeem-coupon-request-state',
        requestState: requestState,
    }
}

export const UpdateAccountInfoAction = (accountInfo: AccountInfo) => {
    return {
        type: 'authentication-update-account-info',
        accountInfo: accountInfo,
    }
}
